var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader-wrapper",class:{ show: _vm.showLoader }},[_c('div',{staticClass:"page-loader"}),_c('span',[_c('b',[_vm._v(_vm._s(_vm.content.title))]),_vm._v(_vm._s(_vm.content.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }